import { Endpoint } from "../config";

export type ChatEndpointType =
  | "getCompanyUsers"
  | "getChatGroups"
  | "createIndividualChat"
  | "createGroupChat"
  | "getGroupInfo"
  | "getCompanyInfo"
  | "getUserInfo"
  | "getMessages"
  | "terminateGroupChat"
  | "getGroupChatMembersById"
  | "createGroupChatById"
  | "createDocumentChatRoom"
  | "searchUsers"
  | "getTierCompanyUsers"
  | "addGroupMembers"
  | "removeGroupMember";

export const chatEndpoints: Record<ChatEndpointType, Endpoint> = {
  getCompanyUsers: {
    url: "chat/company-users/",
  },
  getCompanyInfo: {
    url: "chat/company-users",
  },
  getChatGroups: {
    url: "chat/group/list/",
  },
  createIndividualChat: {
    url: "chat/individual-chat/",
  },
  createGroupChat: {
    url: "chat/group-chat/",
  },
  createGroupChatById: {
    url: "chat/group-chat",
  },
  createDocumentChatRoom: {
    url: "chat/document-chat/",
  },
  getGroupInfo: {
    url: "chat/group-chat",
  },
  getUserInfo: {
    url: "chat/user-details",
  },
  getMessages: {
    url: "chat/messages",
  },
  terminateGroupChat: {
    url: "chat/[id]/terminate/",
  },
  removeGroupMember: {
    url: "chat/[id]/remove-member/",
  },
  getGroupChatMembersById: {
    url: "chat/group-member-list",
  },
  searchUsers: {
    url: "chat/search-user/",
  },
  getTierCompanyUsers: {
    url: "chat/tier-company-users/",
  },
  addGroupMembers: {
    url: "chat/[id]/add-member/",
  },
};
